// OTPPage.jsx
import React, { useRef, useEffect, useState } from "react";
import FormButtonStyle4 from "../UIElements/FormButton";
import Header from "./Header/header";
import callApi from "../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const OTPPage = ({ contactPhone, setCurrentStep }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [loading, setLoading] = useState(false);
  const firstInputRef = useRef(null);
  const aaSlice = useSelector((state) => state?.aa);
  //console.log(aaSlice);
  const appId = aaSlice?.appId;
  const client_leadId = aaSlice?.leadId;
  const OpportunityId = aaSlice?.OpportunityId;
  const responseId = aaSlice?.responseId;
  const user = useSelector((state) => state.app.user);
  const lead_Id = aaSlice?.internalLeadId;
  const [ipAddress, setIpAddress] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [reqid, setReqid] = useState(null);

  const lead = aaSlice?.userData;
  let mobile = lead.contact_phone;
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        setIpAddress(data.ip);
        setLatitude(data.latitude);
        setLongitude(data.longitude);
      } catch (error) {
        console.error("Failed to fetch location data:", error);
      }
    };

    fetchLocation();
  }, []);

  // 🔹 Retry util
  const withRetry = async (fn, retries = 1, delay = 1000) => {
    let attempt = 0;
    while (attempt < retries) {
      try {
        return await fn();
      } catch (err) {
        attempt++;
        if (attempt >= retries) throw err;
        console.warn(`Retrying... attempt ${attempt}`);
        await new Promise((res) => setTimeout(res, delay * attempt));
      }
    }
  };

  const callApiWithRetryAndTest = async (apiFunc, testFunc, errorMsg) => {
    return await withRetry(async () => {
      const res = await apiFunc();
      if (testFunc && !testFunc(res)) {
        throw new Error(errorMsg || "Validation failed");
      }
      return res;
    });
  };

  // 🔹 function to generate OTP
  const generateOtp = async (
    responseId,
    mobile,
    client_leadId,
    showToast = true
  ) => {
    try {
      let genRes = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/lender/otp_generation`,
            "post",
            {
              lenderResponseID: responseId,
              contact_phone: mobile,
              dmi_lead_id: client_leadId,
            },
            "loan"
          ),
        (res) => res?.data?.verdict === "success",
        "❌ OTP Generation failed"
      );

      //console.log("✅ OTP Generated:", genRes?.data); // ✅ only log data

      if (showToast) {
        toast.success("OTP has been sent to your mobile number!");
      }

      return genRes?.data; // return just the useful payload
    } catch (err) {
      console.error("OTP Generation Error:", err?.message || err);
      toast.error("Failed to generate OTP. Please try again.");
      throw err;
    }
  };

  // 🔹 OTP Generation on mount

  useEffect(() => {
    const generateOtp = async () => {
      setLoading(true);
      try {
        let genRes = await callApiWithRetryAndTest(
          () =>
            callApi(
              `v1/lender/otp_generation`,
              "post",
              {
                lenderResponseID: responseId,
                contact_phone: mobile,
                dmi_lead_id: client_leadId,
              },
              "loan"
            ),
          (res) => res?.data?.verdict === "success", // success check
          "❌ OTP Generation failed"
        );
        // console.log(genRes?.data?.data?.request_id);
        setReqid(genRes?.data?.data?.request_id);
        // genRes = {
        //   status: "Success",
        //   data: {
        //     data: { request_id: "906968" },
        //     verdict: "success",
        //     time: "2025-08-11 07:57:23 PM",
        //     message: "otp sms request is created",
        //   },
        // };

        //console.log("✅ OTP Generated:", genRes);
        toast.success("OTP has been sent to your mobile number!"); // ✅ toast
        firstInputRef.current?.focus();
      } catch (err) {
        console.error(err);
        toast.error("Failed to generate OTP. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    generateOtp();
  }, [client_leadId, responseId, contactPhone]);

  // 🔹 OTP Input Handling
  const handleChange = (e, idx) => {
    const val = e.target.value.replace(/\D/, "");
    if (!val) return;
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);

    if (idx < 5) {
      const nextInput = document.getElementById(`otp-${idx + 1}`);
      nextInput && nextInput.focus();
    }
  };

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[idx] = ""; // clear current input
      setOtp(newOtp);

      if (!otp[idx] && idx > 0) {
        // move focus to previous input only if current was already empty
        const prevInput = document.getElementById(`otp-${idx - 1}`);
        prevInput && prevInput.focus();
      }
    }
  };

  // 🔹 OTP Verification
  const handleSubmit = async () => {
    const reqOtp = otp.join("");
    if (reqOtp.length < 6) return toast.error("Please enter 6-digit OTP");

    setLoading(true);
    try {
      let authRes = await callApiWithRetryAndTest(
        () =>
          callApi(
            `v1/lender/otp_authentication`,
            "post",
            {
              lenderResponseID: responseId,
              contact_phone: mobile,
              req_otp: reqid,
              otp: reqOtp,
            },
            "loan"
          ),
        (res) => res?.data?.verdict === "success",
        "❌ OTP Authentication failed"
      );
      // authRes = {
      //   status: "Success",
      //   data: {
      //     data: {
      //       request_id: 906968,
      //       score: "-2",
      //       verify: "new",
      //       score_info: { score: "-2" },
      //     },
      //     message: "credit score is available",
      //     time: "2025-08-11 08:03:05 PM",
      //     verdict: "success",
      //   },
      // };
      if (authRes?.data?.verdict === "success") {
        let kfs_signing = await withRetry(
          () =>
            callApi(
              "v1/lender/kfs_signing_api?lender_id=67b82660c4058e568491673c",
              "post",
              {
                application_id: appId,
                dmi_lead_id: client_leadId,
                lenderResponseID: responseId,
                ip_address: ipAddress,
                longitude,
                latitude,
                dmi_opportunityid: OpportunityId,
                id: lead_Id,
                otp: reqOtp,
                otprequesttime: authRes?.data?.data?.time,
              },
              "loan"
            ),
          1, // retry once
          2000 // wait 2s before retry
        );
        // kfs_signing = {
        //   status: "Success",
        //   data: {
        //     statuscode: "00",
        //     body: {
        //       "description ": "success",
        //       status: "success",
        //     },
        //   },
        // };
        await callApiWithRetryAndTest(
          () =>
            withRetry(
              async () =>
                callApi(
                  `v1/lead/${lead_Id}/update-lead-new`,
                  "post",
                  {
                    lead: {
                      otp,
                      otprequesttime: new Date().toISOString(),
                      is_otp_completed: true,
                      steps_completed: 14,
                    },
                  },
                  "core",
                  user?.token ||
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2OTAxYjljZjIxZTZlNTJmYTQwNDAwNDkiLCJvdHAiOiIxMTExIiwiY29udGFjdF9waG9uZSI6Ijk2OTMxMzU0NjYiLCJvdHBfZXhwaXJ5IjoiMjAyNS0xMC0yOVQwNzowMzowMy43MDZaIiwiaWF0IjoxNzYxNzIwNzg3fQ.xJ3Qd29aQPzV6vfc-bm5XDaOyIF1dXI4dD3lRZxEBDo" // <-- replace with actual token (same as in Authorization header)
                ),
              3, // retries
              1000 // delay
            ),
          (res) => res?.status === "Success", // test function
          "❌ Update lead failed"
        );

        //console.log("✅ OTP Verified:", authRes);
        //toast.success("OTP verified successfully!");
        setCurrentStep((prev) => prev + 1);
      }
    } catch (err) {
      console.error(err);
      //setCurrentStep((prev) => prev + 2); //testing
      toast.error("OTP verification failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col font-atkinson min-h-[100dvh] justify-start bg-gray-300">
      <Header />

      <div className="flex flex-col items-center justify-center h-full border bg-white rounded-t-3xl mt-auto px-4 py-5">
        <div className="w-full max-w-[400px] bg-white p-6">
          <h2 className="text-lg font-bold mb-2 text-center">Enter OTP</h2>
          <p className="text-sm text-center mb-6">
            Enter the 6-digit OTP sent to <strong>{contactPhone}</strong>
          </p>

          <div className="flex gap-2 justify-center mt-4 mb-6">
            {otp.map((value, idx) => (
              <input
                key={idx}
                id={`otp-${idx}`}
                type="tel"
                maxLength={1}
                value={value}
                ref={idx === 0 ? firstInputRef : null}
                onChange={(e) => handleChange(e, idx)}
                onKeyDown={(e) => handleKeyDown(e, idx)}
                className="w-12 h-12 xs:w-10 xs:h-10 border-[1px] border-gray-300 bg-gray-100 text-center font-bold rounded-[10px] focus:border-blue-400 focus:outline-none"
              />
            ))}
          </div>

          <FormButtonStyle4
            className="w-full"
            text={loading ? "Processing..." : "Verify OTP"}
            onClick={handleSubmit}
            disabled={loading}
          />

          <p className="text-xs text-gray-500 mt-auto text-center">
            Didn't receive OTP?{" "}
            <button
              onClick={() =>
                generateOtp(responseId, mobile, client_leadId, true)
              }
              className="text-blue-600"
            >
              Resend
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default OTPPage;
